<script setup lang="ts">
import { type PropType } from 'vue';
import GaiaFormField from '../../../base/GaiaFormField.vue';
import GaiaInputNumber from '../../../base/inputs/GaiaInputNumber.vue';
import GaiaText from '../../../base/GaiaText.vue';
import type { CalendarWizardForm } from '@/composables/useCalendarWizard';

const props = defineProps({
  form: {
    type: Object as PropType<CalendarWizardForm>,
    required: true,
  },
});

const emit = defineEmits<{ 'update:form': [form: CalendarWizardForm] }>();

function patch(changes: Partial<CalendarWizardForm>): void {
  emit('update:form', { ...props.form, ...changes });
}
</script>

<template>
  <n-flex vertical :size="18" :wrap="false">
    <gaia-text size="body" tone="tertiary" :style="{ maxWidth: '68ch', lineHeight: 1.55 }">
      When this calendar extracts a date, a reminder email is sent on the Monday a number of weeks
      before that date. 0 = the Monday of the same week, 1 = the Monday one week before, and so on.
      Leave empty for no reminder.
    </gaia-text>

    <n-grid :cols="2" :x-gap="16">
      <n-gi>
        <gaia-form-field label="First reminder" hint="Weeks before the extracted date">
          <gaia-input-number
            :value="props.form.firstReminderWeeks"
            :min="0"
            clearable
            size="medium"
            placeholder="No reminder"
            style="width: 100%"
            @update:value="(value: number | null) => patch({ firstReminderWeeks: value })"
          />
        </gaia-form-field>
      </n-gi>
      <n-gi>
        <gaia-form-field label="Second reminder" hint="Weeks before the extracted date">
          <gaia-input-number
            :value="props.form.secondReminderWeeks"
            :min="0"
            clearable
            size="medium"
            placeholder="No reminder"
            style="width: 100%"
            @update:value="(value: number | null) => patch({ secondReminderWeeks: value })"
          />
        </gaia-form-field>
      </n-gi>
    </n-grid>
  </n-flex>
</template>
